import React from 'react'
import { useTranslation } from 'react-i18next';
import Course from '../../images/hero/courses-emul.png'
import Batch from '../../images/hero/batch-emul.png'
import Recette from '../../images/hero/recette-emul.png'
import {useNavigate} from "react-router-dom";
import {START_BATCH} from "../../routes";
import Section from "./Section";
import {Box, Typography, useTheme} from "@mui/material";
import Button from "@mui/material/Button";
import {IBatch} from "../../api/IRecipe";


const Services = ({batch}:{batch: IBatch}): JSX.Element => {
  const navigate = useNavigate()
  const theme = useTheme()
  const { t } = useTranslation();

  return (
    <Section

      title={t('pages.services.title')}
      subtitle={t('pages.services.subtitle')}
     // containerStyle={{backgroundColor: `${theme.palette.mode === "light" ? lighten(theme.palette.secondary.light, 0.7) : darken(theme.palette.secondary.dark, 0.7)}`}}
    >
      <Box className={"m-auto h-100 row align-items-center justify-content-end"}>
        <div className={"col-12 col-lg-7 align-self-baseline mb-4 d-flex d-lg-block"}>
          <p className="step-number">{t('pages.services.step1.number')}</p>
          <Typography sx={{fontSize: '1rem'}} className="mt-lg-5" style={{whiteSpace: 'pre-line'}}>
            {t('pages.services.step1.text')}
          </Typography>


        </div>
        <div className={"col-12 col-lg-5 align-self-end mt-lg-5 d-flex"}>
          <img className="m-auto ms-lg-auto" src={Batch}/>
        </div>
      </Box>

      <Box className={" m-auto h-100 row align-items-center"}>
        <div className={"order-2 order-lg-1 col-12 col-lg-5 align-self-end mt-lg-5 d-flex"}>
          <img className="m-auto me-lg-auto" src={Recette}/>
        </div>
        <div className={"order-1 order-lg-2 col-12 col-lg-7 align-self-baseline my-4  d-flex d-lg-block"}>
          <p className="step-number">{t('pages.services.step2.number')}</p>
          <Typography sx={{fontSize: '1rem'}} className="mt-lg-5">{t('pages.services.step2.text')}</Typography>
        </div>
      </Box>

      <Box className={" m-auto h-100 row align-items-center justify-content-end"}>
        <div className={"col-12 col-lg-7 align-self-baseline my-4 d-flex d-lg-block"}>
          <p className="step-number">{t('pages.services.step3.number')}</p>
          <Typography sx={{fontSize: '1rem'}} className="mt-lg-5">
            {t('pages.services.step3.text')}
          </Typography>
          <div className={"d-none d-lg-block"}>
            <Button
              sx={{ height: 'fit-content', marginTop: '2rem'}}
              color="warning"
              size="large"
              variant={"contained"}
              onClick={() => {navigate(START_BATCH, {state: {suggestedBatch: batch}})}}
            >{t('pages.services.step3.button')}
            </Button>
          </div>
        </div>
        <div className={"col-12 col-lg-5 align-self-end mt-lg-5 d-flex"}>
          <img className="m-auto ms-lg-auto" src={Course}/>
        </div>
      </Box>

    </Section>
  )
}
export default Services;
